// extracted by mini-css-extract-plugin
export default {"title":"NotFound_title__umwtd","icon":"NotFound_icon__-vfjq"};